'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ISC_CALENDAR_LINK = undefined;

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isProd = _enviro2.default.isProd();

var ISC_CALENDAR_LINK = exports.ISC_CALENDAR_LINK = isProd ? 'https://app.hubspot.com/meetings/salesinquiries' : 'https://meetings.hubspot.com/vhtran';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/constants/meetingLinks.js
// module id = 300
// module chunks = 3 4 5